export default __webpack_public_path__ + "static/media/vee_banner.e5de2590.jpg";